var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 18.489,
    viewBox: "0 0 13 18.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11189",
    "data-name": "Group 11189",
    transform: "translate(-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11186",
    "data-name": "Group 11186",
    transform: "translate(76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11185",
    "data-name": "Group 11185",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16674",
    "data-name": "Path 16674",
    d: "M82.5,0a6.5,6.5,0,0,0-5.53,9.918l5.16,8.315a.542.542,0,0,0,.46.256h0a.542.542,0,0,0,.46-.263l5.028-8.4A6.5,6.5,0,0,0,82.5,0Zm4.653,9.274-4.571,7.633L77.891,9.347a5.42,5.42,0,1,1,9.262-.073Z",
    transform: "translate(-76)",
    fill: "#666"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11188",
    "data-name": "Group 11188",
    transform: "translate(79.25 3.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11187",
    "data-name": "Group 11187",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16675",
    "data-name": "Path 16675",
    d: "M169.25,90a3.25,3.25,0,1,0,3.25,3.25A3.254,3.254,0,0,0,169.25,90Zm0,5.424a2.174,2.174,0,1,1,2.17-2.174A2.176,2.176,0,0,1,169.25,95.424Z",
    transform: "translate(-166 -90)",
    fill: "#666"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.f82af7b67fa6a0fcb85cf6d889099487.svg";
export { ForwardRef as ReactComponent };